import { deepEqual } from "./deep-equal";

export function match<T>(a: T, b: T, props: readonly (keyof T)[]): boolean {
  return props.every((prop) => deepEqual(a[prop], b[prop]));
}
